import { render, staticRenderFns } from "./TableColumn.vue?vue&type=template&id=6e5b420c&"
import script from "./TableColumn.vue?vue&type=script&lang=ts&"
export * from "./TableColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports